
import ExcelJS from "exceljs/dist/exceljs.min.js";

export const exportToXLSX = async (_data = [], colorRanges = [], footerText = "", fileName = 'plik') => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Raport");

  const headers = _data.map(el => Object.keys(el)).at(0);

  worksheet.addRow(headers);
  const data = _data.map(el => Object.values(el));

  data?.forEach((row) => worksheet.addRow(row));

  const headerRow = worksheet.getRow(1);
  colorRanges?.forEach(({ range, header }) => {
    for (let i = range[0]; i <= range[1]; i++) {
      const cell = headerRow.getCell(i);
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: header },
      };
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }
  });

  worksheet?.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return;
    colorRanges.forEach(({ range, data }) => {
      for (let i = range[0]; i <= range[1]; i++) {
        const cell = row.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: data },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      }
    });
  });

  worksheet.columns?.forEach((col) => {
    let max = 10;
    col.eachCell({ includeEmpty: true }, (c) => {
      const val = c.value ? c.value.toString().split("\n").at(0).length : 0;
      if (val > max) max = val;
    });
    col.width = max + 2;
  });

  worksheet.addRow([]);
  worksheet.addRow([footerText]);

  const excelBuffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  return new File([blob], `${fileName}.xlsx`);
};

// Przykład użycia funkcji
//   const dataToXls = printData?.listDevicesOnReckoning?.map((el, idx) => ({
//     "Lp.": idx + 1,
//     "Model urządzenia": `${el?.device?.printerModel?.manufacturer?.entryName} ${el?.device?.printerModel?.modelName}`,
//     "Oddział": el?.device?.branch?.name,
//     "Lokalizacja urządzenia": el?.device?.addressFloor,
//     "S/N": el?.device?.serialNumber,
//     "Koszt miesięczny": el?.fullCosts?.toFixed(2),
//     "\n": " ",
//     "Abonament": el?.contractType === "SUBSCRIPTION" ? el?.subscription?.toFixed(2) : DEFAULT?.toFixed(2),
//     "Koszt wydruków mono \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyMonoAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
//     "Liczba wydruków mono \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyMonoAbove : DEFAULT,
//     "Koszt wydruków kolor \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyColorAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
//     "Liczba wydruków kolor \n ponad abonament": el?.contractType === "SUBSCRIPTION" ? el?.monthlyColorAbove : DEFAULT,
//     " \n ": " ",
//     "Najem": el?.contractType === "FLEXIBLE" ? el?.subscription?.toFixed(2) : DEFAULT?.toFixed(2),
//     // "Monitoring": el?.monitoringCost,
//     // "Koszt wydruku mono": el?.monoSingleCost,
//     "Koszt wydruków mono": el?.contractType === "FLEXIBLE" ? el?.monthlyMonoAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
//     "Liczba wydruków mono": el?.contractType === "FLEXIBLE" ? el?.monthlyMonoAbove : DEFAULT,
//     // "Koszt wydruku kolor": el?.colorSingleCost,
//     "Koszt wydruków kolor": el?.contractType === "FLEXIBLE" ? el?.monthlyColorAboveCost?.toFixed(2) : DEFAULT.toFixed(2),
//     "Liczba wydruków kolor": el?.contractType === "FLEXIBLE" ? el?.monthlyColorAbove : DEFAULT,
//     // "Koszt wydruku skan": el?.monthlyScanCost,
//     // "Nakład skan": el?.monthlyScanAbove,
//     // "Koszt nakładu skan": el?.monthlyScanAboveCost,
//   }))

//   const headerColors = [
//     "FFF5CBA7",
//     "FF9BBB59",
//     "FF8064A2",
//     "f5b227",
//     "FF4F81BD",
//     "FF9BC2E6",
//     "BAF1BF",
//   ];

//   const dataColors = [
//     "FFFBE9DC",
//     "FFD9EAD3",
//     "FFEADCF0",
//     "FFE89C",
//     "FFDCE6F1",
//     "FFE9F2FB",
//     "E6EBD7",
//   ];

//   const colorRanges = [
//     { range: [1, 5], header: headerColors[0], data: dataColors[0] },
//     { range: [6, 6], header: headerColors[1], data: dataColors[1] },

//     { range: [8, 8], header: headerColors[2], data: dataColors[2] },
//     { range: [9, 10], header: headerColors[6], data: dataColors[6] },
//     { range: [11, 12], header: headerColors[5], data: dataColors[5] },

//     { range: [14, 14], header: headerColors[0], data: dataColors[0] },
//     { range: [15, 16], header: headerColors[4], data: dataColors[4] },
//     { range: [17, 18], header: headerColors[5], data: dataColors[5] },
//   ];

